import type { PropsWithChildren } from 'react'
import { createContext, useCallback, useState } from 'react'

import type { ApiError } from '../../gateways/api'
import { Alerts } from '../components/Alerts'

export { AlertContext, AlertProvider }

const ERROR_DURATION = 10000
const SUCCESS_DURATION = 3000

type AlertContextType = {
  alert: AlertType
  successAlert: (message: string) => void
  errorAlert: (title: string, error: ApiError) => void
  clear: () => void
}

type AlertType = {
  severity: 'none' | 'success' | 'error'
  title?: string
  message?: string
  messageDetail?: string
  duration?: number
}

const AlertContext = createContext<AlertContextType | null>(null)

const AlertProvider = ({ children }: PropsWithChildren) => {
  const [alert, setAlert] = useState<AlertType>({
    severity: 'none',
  })

  const successAlert = useCallback((title: string) => {
    setAlert({
      severity: 'success',
      title,
      duration: SUCCESS_DURATION,
    })
  }, [])

  const errorAlert = useCallback(
    (title: string, { message, messageDetail }: ApiError) => {
      setAlert({
        severity: 'error',
        title,
        message,
        messageDetail,
        duration: ERROR_DURATION,
      })
    },
    [],
  )

  return (
    <AlertContext.Provider
      value={{
        alert,
        successAlert,
        errorAlert,
        clear: () =>
          setAlert({
            severity: 'none',
          }),
      }}
    >
      {children}

      <Alerts />
    </AlertContext.Provider>
  )
}
